module.exports = __webpack_public_path__ + "img/tu07.880c8493.jpg";